<!-- SIDE PANEL -->
<ng-container *ngIf="hasLeftBar">
  <app-facility-left-sidebar *ngIf="customConfig && customConfig.sidebar === 'DefaultSidebar'">
  </app-facility-left-sidebar>
</ng-container>

<ng-container>
</ng-container>

<!-- / SIDE PANEL -->

<div id="main">

  <!-- TOOLBAR: Above fixed -->
  <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'above-fixed'">
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  </ng-container>
  <!-- / TOOLBAR: Above fixed -->

  <div id="container-1" class="container" fusePerfectScrollbar (scroll)="onContentScroll($event)"
    [fusePerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}">

    <!-- TOOLBAR: Above static -->
    <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'above-static'">
      <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    </ng-container>
    <!-- / TOOLBAR: Above static -->

    <div id="container-2" class="container" style="height: 100%; overflow: hidden;"
      [ngStyle]="{'background': staffDirectory ? '#F7F9FA' : null}">

      <div id="container-3" class="container">

        <!-- TOOLBAR: Below -->
        <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'below'">
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        </ng-container>
        <!-- / TOOLBAR: Below -->

        <!-- / MAIN MENU -->

        <!-- CONTENT -->
        <content style="height: 10px; overflow: auto;"></content>
        <!-- / CONTENT -->

        <!-- FOOTER: Below -->
        <ng-container *ngIf="fuseConfig.layout.footer.position === 'below'">
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        </ng-container>
        <!-- / FOOTER: Below -->

      </div>

    </div>

    <!--<button mat-button class="scroll-to-top" *ngIf="showScrollToTop" (click)="scrollContainerToTop()">-->
    <!--<mat-icon>keyboard_arrow_up</mat-icon>-->
    <!--</button>-->

  </div>


</div>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS ------------------------------------------------------------------------------------------ -->

<!-- TOOLBAR -->
<ng-template #toolbar>
  <toolbar *ngIf="!fuseConfig.layout.toolbar.hidden"
    [toolbarTheme]="customConfig.navbar === 'DefaultNavbar' ? 'default' : 'light'" [navbar]="customConfig.navbar"
    [ngStyle]="{background: customConfig.navbar === 'DefaultNavbar' ? null : '#FFFFFF'}"
    [ngClass]="fuseConfig.layout.toolbar.customBackgroundColor === true ?
           fuseConfig.layout.toolbar.position + ' ' + fuseConfig.layout.toolbar.background : fuseConfig.layout.toolbar.position" [ngClass]="{'shadow-box': addToolbarShadow()}">
  </toolbar>
</ng-template>
<!-- / TOOLBAR -->
